'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var Topology = require('./index');

var multicodecTopologySymbol = Symbol.for('@libp2p/js-interfaces/topology/multicodec-topology');

var MulticodecTopology = /*#__PURE__*/function (_Topology, _Symbol$toStringTag) {
  _inherits(MulticodecTopology, _Topology);

  var _super = _createSuper(MulticodecTopology);

  /**
   * @param {TopologyOptions & MulticodecOptions} props
   */
  function MulticodecTopology(_ref) {
    var _this;

    var min = _ref.min,
        max = _ref.max,
        multicodecs = _ref.multicodecs,
        handlers = _ref.handlers;

    _classCallCheck(this, MulticodecTopology);

    _this = _super.call(this, {
      min: min,
      max: max,
      handlers: handlers
    });

    if (!multicodecs) {
      throw new Error('one or more multicodec should be provided');
    }

    if (!handlers) {
      throw new Error('the handlers should be provided');
    }

    if (typeof handlers.onConnect !== 'function') {
      throw new Error('the \'onConnect\' handler must be provided');
    }

    if (typeof handlers.onDisconnect !== 'function') {
      throw new Error('the \'onDisconnect\' handler must be provided');
    }

    _this.multicodecs = Array.isArray(multicodecs) ? multicodecs : [multicodecs];
    _this._registrar = undefined;
    _this._onProtocolChange = _this._onProtocolChange.bind(_assertThisInitialized(_this));
    _this._onPeerConnect = _this._onPeerConnect.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MulticodecTopology, [{
    key: _Symbol$toStringTag,
    get: function get() {
      return 'Topology';
    }
  }, {
    key: multicodecTopologySymbol,
    get: function get() {
      return true;
    }
    /**
     * Checks if the given value is a `MulticodecTopology` instance.
     *
     * @param {any} other
     * @returns {other is MulticodecTopology}
     */

  }, {
    key: "registrar",
    set:
    /**
     * @param {any} registrar
     */
    function set(registrar) {
      // eslint-disable-line
      this._registrar = registrar;

      this._registrar.peerStore.on('change:protocols', this._onProtocolChange);

      this._registrar.connectionManager.on('peer:connect', this._onPeerConnect); // Update topology peers


      this._updatePeers(this._registrar.peerStore.peers.values());
    }
    /**
     * Update topology.
     *
     * @param {Array<{id: PeerId, multiaddrs: Array<Multiaddr>, protocols: Array<string>}>} peerDataIterable
     * @returns {void}
     */

  }, {
    key: "_updatePeers",
    value: function _updatePeers(peerDataIterable) {
      var _this2 = this;

      var _iterator = _createForOfIteratorHelper(peerDataIterable),
          _step;

      try {
        var _loop = function _loop() {
          var _step$value = _step.value,
              id = _step$value.id,
              protocols = _step$value.protocols;

          if (_this2.multicodecs.filter(function (multicodec) {
            return protocols.includes(multicodec);
          }).length) {
            // Add the peer regardless of whether or not there is currently a connection
            _this2.peers.add(id.toB58String()); // If there is a connection, call _onConnect


            var connection = _this2._registrar.getConnection(id);

            connection && _this2._onConnect(id, connection);
          } else {
            // Remove any peers we might be tracking that are no longer of value to us
            _this2.peers.delete(id.toB58String());
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Check if a new peer support the multicodecs for this topology.
     *
     * @param {Object} props
     * @param {PeerId} props.peerId
     * @param {Array<string>} props.protocols
     */

  }, {
    key: "_onProtocolChange",
    value: function _onProtocolChange(_ref2) {
      var _this3 = this;

      var peerId = _ref2.peerId,
          protocols = _ref2.protocols;
      var hadPeer = this.peers.has(peerId.toB58String());
      var hasProtocol = protocols.filter(function (protocol) {
        return _this3.multicodecs.includes(protocol);
      }); // Not supporting the protocol anymore?

      if (hadPeer && hasProtocol.length === 0) {
        this._onDisconnect(peerId);
      } // New to protocol support


      var _iterator2 = _createForOfIteratorHelper(protocols),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var protocol = _step2.value;

          if (this.multicodecs.includes(protocol)) {
            var peerData = this._registrar.peerStore.get(peerId);

            this._updatePeers([peerData]);

            return;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * Verify if a new connected peer has a topology multicodec and call _onConnect.
     *
     * @param {Connection} connection
     * @returns {void}
     */

  }, {
    key: "_onPeerConnect",
    value: function _onPeerConnect(connection) {
      // @ts-ignore - remotePeer does not existist on Connection
      var peerId = connection.remotePeer;

      var protocols = this._registrar.peerStore.protoBook.get(peerId);

      if (!protocols) {
        return;
      }

      if (this.multicodecs.find(function (multicodec) {
        return protocols.includes(multicodec);
      })) {
        this.peers.add(peerId.toB58String());

        this._onConnect(peerId, connection);
      }
    }
  }], [{
    key: "isMulticodecTopology",
    value: function isMulticodecTopology(other) {
      return Boolean(other && other[multicodecTopologySymbol]);
    }
  }]);

  return MulticodecTopology;
}(Topology, Symbol.toStringTag);
/**
 * @typedef {import('peer-id')} PeerId
 * @typedef {import('multiaddr')} Multiaddr
 * @typedef {import('../connection/connection')} Connection
 * @typedef {import('.').Options} TopologyOptions
 * @typedef {Object} MulticodecOptions
 * @property {string[]} multicodecs - protocol multicodecs
 * @property {Required<Handlers>} handlers
 * @typedef {import('.').Handlers} Handlers
 */


module.exports = MulticodecTopology;